import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource-variable/gabarito'
import './akkumost.css'
import App from './App'

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<App />
	</StrictMode>,
)
